import axios from "axios";
import DeleteConfirmationModal from  "../components/modals/DeleteConfirmationModal";

export default {
    components: {
        DeleteConfirmationModal
    },
    data() {
        return {
            showDeleteModal: false,
        }
    },
    methods: {
        deleteModal: function(){
            document.body.className = 'overflow-hidden';
            this.$store.commit('TOGGLE_MODAL', { open: true });
            this.showDeleteModal = true;
        },
        closeDeleteModal: function(){
            if (this.showDeleteModal){
                document.body.className = '';
                this.$store.commit('TOGGLE_MODAL', { open: false });
                this.showDeleteModal = false;
            }
        },
        deleteItem: function(){
            this.$Progress.start();

            axios.delete(process.env.VUE_APP_API_URL + '/'+this.resource+'/'+this.item.id).then(response => {
                let message;

                if (response.data.success){
                    this.showDeleteModal = false;

                    document.body.className = '';
                    this.$store.commit('TOGGLE_MODAL', { open: false });

                    this.$router.push(this.return);

                    if (response.data.message){
                        message = response.data.message;
                    } else {
                        message = 'Successfully Deleted Record!';
                    }

                    this.$notify({
                        group: 'main',
                        position: 'top center',
                        type: 'success',
                        title: 'Success',
                        text: message,
                        duration: 10000,
                        speed: 1000
                    });
                }

                this.$Progress.finish();
            })
                .catch(() => {
                    this.$Progress.finish();
                });
        },
    }
}
